import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { DrainageProcess } from '../../features';
import { useOrder } from '../../context/OrderContext';

const DrainageProcessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: orderState, dispatch } = useOrder();

    // Check if we're in edit mode
    const isEditMode = location.state?.editMode;
    // Get the index of the item being edited from the cart
    const editItemIndex = location.state?.itemIndex;

    const handleDrainageComplete = (drainageConfig) => {
        // If we're not in edit mode and have a product configured, ensure it gets added to cart
        if (!isEditMode && orderState.orderDetails.productCode && !orderState.orderDetails.addedToCart) {
            // Check if main profile article is already in cart
            const hasMainProfileArticle = Array.isArray(orderState.cartItems) &&
                orderState.cartItems.some(item => !item.isStandaloneArticle && !item.isDrainageArticle);
            
            if (!hasMainProfileArticle) {
                console.log('Auto-adding main product to cart after drainage completion');
                // Add the main product to cart
                dispatch({ type: 'ADD_TO_CART' });
            }
        }
        
        // Navigate back to the previous page or to a specific page
        navigate(-1);
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="mb-6">
                <p className="text-center text-gray-600 mt-2">
                    Seleziona le opzioni per lo scarico dell'acqua
                </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6">
                <DrainageProcess
                    onComplete={handleDrainageComplete}
                    isEditMode={isEditMode}
                    editItemIndex={editItemIndex}
                />
            </div>

            <div className="mt-6 text-center">
                <button
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                >
                    Torna Indietro
                </button>
            </div>
        </div>
    );
};

export default DrainageProcessPage;